export enum CountryOptions {
	Belgium = 'België',
	Netherlands = 'Nederland',
	France = 'Frankrijk',
	Germany = 'Duitsland',
	Luxembourg = 'Luxemburg',
	UnitedKingdom = 'Verenigd Koninkrijk',
	Other = 'Andere'
}
